import {initializeApp} from 'firebase/app'
import {getAuth} from 'firebase/auth'

import {config} from '../config'

const firebaseApp = initializeApp({
  apiKey: config.firebaseApiKey,
  authDomain: config.firebaseAuthDomain,
  projectId: config.firebaseProjectId,
})

export const firebaseAuth = getAuth(firebaseApp)
